import {useEffect, useRef, useState} from "react";
import FormControl from "../form/FormControl.jsx";
import Button from "../Button.jsx";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {fas} from "@fortawesome/free-solid-svg-icons";
import {CircleStencil, FixedCropper} from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css'
import Spinner from "../Spinner.jsx";
import FormError from "../form/FormError.jsx";
import Modal from "../Modal.jsx";

export default function ImageCropperModal(
    {
        title,
        visible,
        setVisible,
        onSubmit,
        loading = false,
        error = null,
    }
) {
    let {t} = useTranslation();
    let [loadedImage, setLoadedImage] = useState(null);
    let ref = useRef(null);

    useEffect(() => {
        if (!visible) {
            setLoadedImage(null);
        }
    }, [visible]);

    const onClick = () => {
        ref.current.getCanvas()?.toBlob((blob) => {
            onSubmit(blob);
        });
    };

    if (!visible) {
        return <span/>;
    }

    return (
        <Modal
            visible={visible}
            setVisible={setVisible}
            title={title}
            className={'max-w-lg'}
        >
            {error && <FormError error={error}/>}

            {loading && <Spinner size={'spinner-large'} className={'m-auto'}/>}

            {loadedImage === null && !loading &&
                <section>
                    <FormControl
                        type={'file'}
                        onChange={(e) => setLoadedImage(e.target.files[0])}
                    />
                </section>
            }

            {loadedImage !== null && !loading &&
                <div>
                    <section className={'bg-red-500 mx-auto aspect-square w-10/12'}>
                        <FixedCropper
                            src={URL.createObjectURL(loadedImage)}
                            className={'cropper aspect-square'}
                            stencilSize={{width: 256, height: 256}}
                            stencilProps={{
                                handlers: false,
                                lines: true,
                                movable: false,
                                resizable: false
                            }}
                            stencilComponent={CircleStencil}
                            ref={ref}
                        />
                    </section>

                    <div className={'text-right pt-4 mx-auto w-10/12 min-w-64 max-w-96'}>
                        <Button
                            className={'button-primary'}
                            onClick={() => onClick()}
                        >
                            {t('save')}
                        </Button>
                    </div>
                </div>
            }
        </Modal>
    );
}
